import { render, staticRenderFns } from "./OwalTransitionSunrise.vue?vue&type=template&id=4638e51e&scoped=true"
import script from "./OwalTransitionSunrise.vue?vue&type=script&lang=js"
export * from "./OwalTransitionSunrise.vue?vue&type=script&lang=js"
import style0 from "./OwalTransitionSunrise.vue?vue&type=style&index=0&id=4638e51e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../owal/js/cameras/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4638e51e",
  null
  
)

export default component.exports